import React from 'react';

/**
 * Cabeçalho do resultado da NC com título, badge de modo e botões de relatório
 * @param {number}   ncId            - ID da NC
 * @param {string}   modoAnalise     - 'registro' | 'investigacao'
 * @param {function} onDownloadReport - Callback para download do relatório HTML
 * @param {function} onShowReportV2   - Callback para mostrar relatório v2.0
 * @param {string}   userRole         - Papel do usuário logado
 * @param {function} onDelete         - Callback para excluir a NC
 */
function NCResultHeader({ ncId, numeroNC, modoAnalise, onDownloadReport, onDownload8D, onShowReportV2, onOpenCopiloto, copilotoMentor, userRole, onDelete, analiseVazia }) {
  const isAdmin = userRole === 'admin';
  const isInvestigacao = modoAnalise === 'investigacao';
  // FIX(F7): exibe o número de NC formatado (ex: RNC-007/2026) em vez
  // do PK do banco. Mantém fallback para NCs criadas antes de existir
  // numero_nc.
  const titulo = numeroNC || `NC-${ncId}`;

  return (
    <div className="result-header">
      <div className="result-header-main">
        {/* #216: o header era incondicional e mentia em NC com análise
            vazia/falha ("concluída" sobre causa "Não identificada"). */}
        <span className="result-header-sub" style={analiseVazia ? { color: '#b45309' } : undefined}>
          {analiseVazia ? 'Análise pendente' : 'Análise de IA Concluída'}
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
          <h2 style={{ margin: 0 }}>Não Conformidade — {titulo}</h2>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.3rem',
              padding: '0.2rem 0.65rem',
              borderRadius: '9999px',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.03em',
              background: isInvestigacao ? '#f5f3ff' : '#eff6ff',
              color: isInvestigacao ? '#7c3aed' : '#1d4ed8',
              border: `1px solid ${isInvestigacao ? '#ddd6fe' : '#bfdbfe'}`,
            }}
          >
            <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
              {isInvestigacao ? 'biotech' : 'fact_check'}
            </span>
            {isInvestigacao ? 'Investigação' : 'Registro'}
          </span>
        </div>
      </div>
      <div className="header-buttons">
        {/* #47/TD106 — Copiloto: chat read-only sobre a NC (gate Pro+ no backend;
            o painel mostra chat ou upsell conforme user.copiloto_liberado).
            Com a flag de MENTOR ON (só Investigação), o gatilho lê "Mentor" e usa
            ícone de ensino — o painel vira tutor/crítico da análise existente. */}
        {onOpenCopiloto && (
          <button onClick={onOpenCopiloto} className="download-btn copiloto-trigger-btn" title={copilotoMentor ? 'Pedir ao Mentor para explicar/criticar esta investigação' : 'Conversar com o Copiloto sobre esta NC'} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>{copilotoMentor ? 'school' : 'forum'}</span> {copilotoMentor ? 'Mentor' : 'Copiloto'}
          </button>
        )}
        <button onClick={onShowReportV2} className="download-btn download-btn-v2" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>assessment</span> Relatório PDF
        </button>
        <button onClick={onDownloadReport} className="download-btn" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>description</span> Relatório HTML
        </button>
        {/* #240 — Export 8D (D1–D8): só na Investigação, que tem 6M/5W2H/hipótese
            (numa NC de Registro o 8D viria majoritariamente em branco). */}
        {isInvestigacao && onDownload8D && (
          <button onClick={onDownload8D} className="download-btn" title="Exportar Relatório 8D (D1–D8)" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>checklist</span> Relatório 8D
          </button>
        )}
        {isAdmin && (
          <button onClick={onDelete} className="download-btn btn-danger-outline" title="Excluir NC (Apenas Admin)" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>delete</span> Excluir
          </button>
        )}
      </div>
    </div>
  );
}

export default NCResultHeader;